import { Channel } from 'stream-chat';
import { StreamChannelType } from '@/api/apis/chat';
import { OrganType, ClinicalItemType } from '@/api/apis/case';

export const filterAvailableChannels = (
  channels: Channel[],
  excludedChatTypes: StreamChannelType[],
  chatGrants: StreamChannelType[] | null,
) => {
  return channels.filter((ch) => {
    const chatType = ch.type as StreamChannelType;
    const isNotExcluded = !excludedChatTypes.includes(chatType);
    const isAllowedByBackend = chatGrants?.includes(chatType) ?? true;
    return isNotExcluded && isAllowedByBackend;
  });
};

export const sanitizeAttachmentForChats = (
  organType?: OrganType,
  clinicalItemType?: ClinicalItemType | undefined,
  attachment?: unknown,
) => {
  const isLungOnOcsVideo = organType === OrganType.Lungs && clinicalItemType === ClinicalItemType.OnOCSVideo;

  if (!isLungOnOcsVideo || attachment == null) return attachment;

  const markInternal = <T extends Record<string, unknown>>(a: T): T => ({
    ...a,
    shared: false,
    sharedExternally: false,
  });

  if (Array.isArray(attachment)) {
    return attachment.map((a) => (a && typeof a === 'object' ? markInternal(a) : a));
  }
  if (typeof attachment === 'object') {
    return markInternal(attachment as Record<string, unknown>);
  }
  return attachment;
};
